import type { ZeytalTokens } from "@zeytal/types";

import { variableAliasKeyword } from "../../utils/tokens.ts";

const formatName = (name: ZeytalTokens.TransformedToken["name"]) => {
  return `@${name}`;
};

const booleanValue = (boolean: boolean) => `${boolean}`;

const numberValue = (number: number) => number.toString();

const stringValue = (
  name: string,
  value: string,
  originType: ZeytalTokens.TransformedToken["originType"],
) => {
  let cleanString = value;

  if (
    originType === "STRING" ||
    (originType === "TEXT" && name.endsWith("font-family"))
  ) {
    cleanString = `"${value}"`;
  } else if (value.startsWith(variableAliasKeyword)) {
    cleanString = `var(${formatName(value.replace(variableAliasKeyword, ""))})`;
  } else {
    cleanString = value === "" ? '""' : value;
  }

  return cleanString;
};

const formatValue = (token: ZeytalTokens.TransformedToken): string => {
  switch (typeof token.value) {
    case "boolean":
      return booleanValue(token.value);
    case "number":
      return numberValue(token.value);
    case "string":
      return stringValue(token.name, token.value, token.originType);
    default:
      return "null";
  }
};

export const translateLess = (variables: ZeytalTokens.TransformedTokensArray) =>
  variables.reduce(
    (acc, item) => `${acc}${formatName(item.name)}: ${formatValue(item)};\n`,
    "",
  );
